import { ref, toRef, watch } from 'vue'
import useCheckScreen from '@/composables/useCheckScreen'

const SORT_BY_DATE = ['invoice_date']

export const useTable = (props) => {
    const { isMobile } = useCheckScreen()
    const columns = toRef(props, 'columns')
    const originalData = toRef(props, 'originalData')
    const data = ref([])
    const mobileData = ref([])
    const table = ref({
        headers: [],
        rows: []
    })

    ;(() => {
        if (!columns.value || !originalData.value) {
            throw new Error('need to pass in columns: column def; and data: data')
        }
    })()

    watch([() => originalData.value, () => isMobile.value], ([data, isMobile]) => {
        data.value = data
        table.value.headers = _initHeaders()
        table.value.rows = _initRows(data)
        if (isMobile) mobileData.value = _initMobileData(table.value.rows)
    })

    function sortBy(accessor, direction, { subAccessor } = null) {
        data.value = [...originalData.value]

        const sorted = [...data.value].sort(function (first, second) {
            let firstValue, secondValue

            if (subAccessor) {
                firstValue = SORT_BY_DATE.includes(accessor)
                    ? new Date(first[accessor][subAccessor])
                    : first[accessor][subAccessor]
                secondValue = SORT_BY_DATE.includes(accessor)
                    ? new Date(second[accessor][subAccessor])
                    : second[accessor][subAccessor]
            } else {
                firstValue = SORT_BY_DATE.includes(accessor) ? new Date(first[accessor]) : first[accessor]
                secondValue = SORT_BY_DATE.includes(accessor) ? new Date(second[accessor]) : second[accessor]
            }

            if (accessor === 'total_amount') {
                firstValue = parseFloat(firstValue)
                secondValue = parseFloat(secondValue)
            }

            if (direction === 'asc') {
                return firstValue > secondValue ? 1 : -1
            } else if (direction === 'desc') {
                return secondValue > firstValue ? 1 : -1
            }
        })

        data.value = sorted
        table.value.rows = _initRows(data.value)
    }

    function _initHeaders() {
        const headers = columns.value.map((col) => {
            const header = col.header

            return {
                ...header,
                accessor: col.accessor,
                actions: {
                    sortDirection: col.actions.sortable ? 'off' : null
                }
            }
        })

        return headers
    }
    function _initRows(data) {
        const rows = []

        data.forEach((d) => {
            const row = columns.value.map((col) => {
                const headerAccessor = col.accessor
                const value = col.cell.render({ val: d[headerAccessor], data: d })

                return {
                    id: d.id,
                    accessor: col.accessor,
                    classes: col.cell.classes,
                    value: value
                }
            })
            rows.push(row)
        })

        return rows
    }

    // Mobile data also goes through processing from column def.
    // This is the main reason to initialize mobile data instead of using raw data
    function _initMobileData(rows) {
        const mobileData = []

        rows.forEach((transaction, index) => {
            mobileData.push({})

            transaction.forEach((data) => {
                mobileData[index][data.accessor] = {
                    id: data.id,
                    value: data.value,
                    page: data.page
                }
            })
        })
        return mobileData
    }

    return { mobileData, table, sortBy }
}
